import { render } from "./payment-type.vue?vue&type=template&id=2ea45c79"
import script from "./payment-type.vue?vue&type=script&lang=js"
export * from "./payment-type.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__